
import { Link } from "react-router-dom";
import { Instagram } from "lucide-react";

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="w-full py-12 bg-white border-t border-gray-100">
      <div className="container max-w-7xl mx-auto px-4">
        <div className="flex flex-col items-center space-y-6">
          <p className="text-gray-600 italic">Empowering your airfryer journey</p>
          <div className="flex items-center">
            <a 
              href="https://www.instagram.com/airfryerai" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-gray-500 hover:text-primary transition-colors hover:scale-110 transform"
            >
              <Instagram className="w-5 h-5" />
            </a>
          </div>
          <div className="flex flex-wrap items-center justify-center gap-6 text-gray-700 text-sm">
            <Link to="/" className="hover:text-primary transition-colors">
              Airfryer AI
            </Link>
            <Link to="/terms" className="hover:text-primary transition-colors">
              Terms of Service
            </Link>
            <span>©{currentYear}</span>
            <span>petterijenssen@gmail.com</span>
          </div>
        </div>
      </div>
    </footer>
  );
};
